import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stf-accordeon',
  templateUrl: './stf-accordeon.component.html',
  styleUrls: ['./stf-accordeon.component.scss'],
})
export class StfAccordeonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
